import { useState, useEffect } from "react";
import { PageTitle } from "../../components";
import {
  Table,
  Space,
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  message,
} from "antd";
import type { ColumnsType } from "antd/lib/table";
import { Link, useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { NewsProp } from "../../_helpers/type";
import { CURRENT_CLUB_ID } from "../../_helpers/constants";
import { newsApi } from "../../_helpers/apiService";

const deleteNews = async (news: any, fetchNews: () => void) => {
  try {
    await newsApi.delete(news.id);
    message.success(`"${news.title}" - мэдээ амжилттай устгалаа.`);
    fetchNews();
  } catch (error: any) {
    console.error("Delete news error:", error);
    message.error("Мэдээ устгахад алдаа гарлаа");
  }
};

function News() {
  const [form] = Form.useForm();
  let navigate = useNavigate();

  const [data, setData] = useState<NewsProp[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<any>(10);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    fetchNews();
  }, [currentPage, pageSize]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await newsApi.getAll({
        club_id: CURRENT_CLUB_ID,
        skip: (currentPage - 1) * pageSize,
        limit: pageSize,
        sort_by: 'created_at',
        sort_order: 'desc'
      });

      const news = response.data.items.map((item: any) => ({
        ...item,
        id: item.id.toString(),
      }));

      setData(news);
      setTotalItems(response.data.total);
    } catch (error: any) {
      console.error("Fetch news error:", error);
      message.error("Мэдээний мэдээлэл татахад алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  const handlePaginationChange = (current: number, pageSize: number) => {
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  const columns: ColumnsType<NewsProp> = [
    {
      title: "#",
      dataIndex: "listNumber",
      key: "listNumber",
      width: 80,
      render: (value, record: any, index) => (
        <Space size="middle">{(currentPage - 1) * pageSize + index + 1}</Space>
      ),
    },
    {
      title: "Нэр",
      dataIndex: "title",
      key: "title",
      width: 200,
    },
    {
      title: "Товч",
      dataIndex: "description",
      key: "description",
      width: 250,
      render: (value, record: any) => <Space size="middle">{value}</Space>,
    },
    {
      title: "Өдөр",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (value, record: any) => (
        <Space size="middle">
          {value ? dayjs(value).format("YYYY-MM-DD HH:mm") : "-"}
        </Space>
      ),
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 150,
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/news/${record.id}`}>
            <Button type="link">Засах</Button>
          </Link>
          <Popconfirm
            title="Устгахдаа итгэлтэй байна уу?"
            onConfirm={() => deleteNews(record, fetchNews)}
            okText="Тийм"
            cancelText="Үгүй"
          >
            <Button type="link" danger>Устгах</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTitle
        title="Мэдээ"
        description="Мэдээний жагсаалт"
        right={
          <Button
            shape="round"
            onClick={() => navigate("/add-news")}
            icon={<PlusOutlined />}
            size="large"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Мэдээ нэмэх
          </Button>
        }
      />
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={data}
                      loading={loading}
                      rowKey={(item) => item.id}
                      scroll={{ x: 'max-content' }}
                      pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: totalItems,
                        onChange: handlePaginationChange,
                        showSizeChanger: true,
                        showTotal: (total) => `Нийт: ${total}`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default News;
